import React , { useState } from 'react'
import { useSelector , useDispatch } from 'react-redux'
import { set_selected_database_id } from '../../../../slices/Select_DB_Modal/reducer';

const DB_List = ({ ele }) => {
    const {Type,Connection_Name, Database_ID , Database_Name , Group_ID , IP,Port}= ele;
    const dispatch = useDispatch()
    const select_db_modal_state = useSelector((state)=> state.Select_DB_Modal)

     
  return (
    <tr>
                                              <td className="">
                                                  <div className="form-check">
                                                      <input checked={Database_ID==select_db_modal_state.database_id} onClick={(e)=>{
                                                            if(e.target.checked){
                                                                dispatch(set_selected_database_id(Database_ID)) 
                                                            }else{

                                                            }
                                                      }}  className="form-check-input" type="checkbox" value="" id="cardtableCheck01" />
                                                      <label className="form-check-label" htmlFor="cardtableCheck01"></label>
                                                  </div>
                                              </td>
                                              <td className="connection_name">{Connection_Name}</td>
                                              <td className="db_type">{Type}</td>
                                              <td className="host">{IP}</td>
                                              <td className="port">{Port}</td>
                                          </tr>
  )
}

export default DB_List